
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Paper } from "@material-ui/core";
import { useEffect, useState } from "react";
import Moment from "react-moment";
import IComment from "../models/Comment";
import { AddCommentDialog } from "./AddCommentDialog";
import UserInfo from "./UserInfo";

interface ICommentsTableProps {
    eventId: string,
    comments: IComment[]
}

export const CommentsTable = (props: ICommentsTableProps) => {
    const [comments, setComments] = useState<IComment[]>([]);

    useEffect(() => {
        setComments(props.comments);
    }, [props.comments]);

    return (
        <Grid item xs={12} md={12} lg={6}>
            <Grid container>
                <Grid item xs={6} md={6} lg={6}>
                    <h2>Comments</h2>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                    <AddCommentDialog eventId={props.eventId} addNoteToTable={(data: IComment) => setComments(comments => [...comments, data])} />
                </Grid>
            </Grid>

            <Paper className="paper">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                Date
                            </TableCell>
                            <TableCell>
                                User
                            </TableCell>
                            <TableCell>
                                Comment
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {comments.map((comment, i) => (
                            <TableRow key={i}>
                                <TableCell>
                                    <Moment format="YYYY-MM-DD HH:MM:SS">{comment.timestamp}</Moment>
                                </TableCell>
                                <TableCell>
                                    <UserInfo key={i} userId={comment.user} />
                                </TableCell>
                                <TableCell>
                                    {comment.comment}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Grid>
    )
}